import { Spin } from '@steinpilz/react-ux/business-app';
import { LoaderWrapper } from './styled';
import { useShowLoader } from '@infrastructure/loader/store/loader';
import { createPortal } from 'react-dom';

export const Loader = () => {
  const show = useShowLoader();

  const onClick = (e: React.MouseEvent) => e.stopPropagation();

  if (!show) {
    return null;
  }

  const portal = createPortal(
    <LoaderWrapper onClick={onClick}>
      <Spin />
    </LoaderWrapper>,
    document.body,
  );
  return portal;
};
